import { getOptions, plcTypeItems } from '@/shared/SelectData'
import { TemplatePlcToolbarProps } from '@/template/interface'
import { getFormatMessage } from '@/utils/utils'
import { SearchOutlined } from '@ant-design/icons'
import { Button, Form, Input, Select, Space } from 'antd'
import React from 'react'

export const TemplatePlcToolbar: React.FC<TemplatePlcToolbarProps> = (
  props: TemplatePlcToolbarProps
) => {
  const { selectable } = props
  const formatMessage = getFormatMessage()
  const [form] = Form.useForm()

  const handleSubmit = () => {
    const value = form.getFieldsValue()
    if (props.onSearch) {
      props.onSearch(value)
    }
  }

  const handleReset = () => {
    form.resetFields()
    if (props.onSearch) {
      props.onSearch(form.getFieldsValue())
    }
  }

  return (
    <Form form={form} layout='inline' style={{ marginBottom: 16 }}>
      <Form.Item name='alias'>
        <Input
          allowClear={true}
          placeholder={formatMessage({
            id: 'app.template.plc.toolbar.alias'
          })}
        />
      </Form.Item>

      <Form.Item name='plcName'>
        <Input
          allowClear={true}
          placeholder={formatMessage({
            id: 'app.template.plc.toolbar.plcName'
          })}
        />
      </Form.Item>

      <Form.Item name='type'>
        <Select
          allowClear={true}
          placeholder={formatMessage({
            id: 'app.template.plc.toolbar.type'
          })}
          style={{ width: 120 }}
        >
          {getOptions(plcTypeItems)}
        </Select>
      </Form.Item>

      <Form.Item>
        <Button type='link' onClick={handleReset}>
          {formatMessage({
            id: 'app.template.plc.toolbar.clear'
          })}
        </Button>
        <Button type='primary' onClick={handleSubmit} icon={<SearchOutlined />}>
          {formatMessage({
            id: 'app.template.plc.toolbar.search'
          })}
        </Button>
      </Form.Item>
      <Form.Item style={{ marginLeft: 'auto' }}>
        <Space>
          <Button type='primary' onClick={props.onCreate}>
            {formatMessage({
              id: 'app.template.plc.toolbar.create'
            })}
          </Button>

          <Button
            type='primary'
            disabled={!selectable}
            onClick={props.onBatchDelete}
          >
            {formatMessage({
              id: 'app.template.plc.toolbar.batchDelete'
            })}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  )
}
